import gql from 'graphql-tag';

const UPDATE_POLLS = gql`
    mutation updatePoll($input: PollInput) {
        updatePoll (input: $input) {
            internalCode
        }
    }
`;

export default UPDATE_POLLS;
